import React from 'react';
import { BiCollapseVertical, BiExpandVertical } from 'react-icons/bi';

import { Tooltip } from 'antd';
import PlanActualSegmented from 'components/common/PlanActualSegmented';
import { InputTaskCategory } from 'interfaces/IInputTask';
import MergeClassNames from 'utils/MergeClassNames';

import { STEP_CATEGORY_FILTERS } from './stepCategoryFilters';

interface InputTasksHeaderProps {
  activeStepCategoryKey: string;
  onStepCategoryChange: (categoryKey: string) => void;
  activeTaskCategory: InputTaskCategory;
  onTaskCategoryChange: (category: InputTaskCategory) => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

const InputTasksHeader: React.FC<InputTasksHeaderProps> = ({
  activeStepCategoryKey,
  onStepCategoryChange,
  activeTaskCategory,
  onTaskCategoryChange,
  onExpandAll,
  onCollapseAll,
}) => (
  <div className="mt-6 flex flex-col gap-4">
    <h2 className="text-lg text-gray-muted">Inputs</h2>
    <div className="flex items-center justify-between gap-4">
      <div className="overflow-x-auto pb-1">
        <div className="flex w-max items-center gap-2">
          {STEP_CATEGORY_FILTERS.map((category) => {
            const isActive = category.key === activeStepCategoryKey;
            return (
              <button
                key={category.key}
                type="button"
                className={MergeClassNames(
                  'rounded-[var(--radius-button)] px-3 py-1.5 text-sm font-semibold',
                  isActive
                    ? 'bg-charcoal text-white'
                    : 'bg-transparent text-gray-dark hover:bg-gray-200'
                )}
                onClick={() => onStepCategoryChange(category.key)}
              >
                {category.label}
              </button>
            );
          })}
          <div className="mx-1 h-5 w-px bg-gray-300" />
          <Tooltip title="Collapse all tasks">
            <button
              type="button"
              aria-label="Collapse all tasks"
              className="inline-flex h-6 w-6 items-center justify-center rounded-[var(--radius-button)] text-secondary-dark hover:bg-gray-200 active:bg-gray-200"
              onClick={onCollapseAll}
            >
              <BiCollapseVertical size={16} />
            </button>
          </Tooltip>
          <Tooltip title="Expand all tasks">
            <button
              type="button"
              aria-label="Expand all tasks"
              className="inline-flex h-6 w-6 items-center justify-center rounded-[var(--radius-button)] text-secondary-dark hover:bg-gray-200 active:bg-gray-200"
              onClick={onExpandAll}
            >
              <BiExpandVertical size={16} />
            </button>
          </Tooltip>
        </div>
      </div>
      <PlanActualSegmented
        value={activeTaskCategory}
        onChange={onTaskCategoryChange}
      />
    </div>
  </div>
);

export default InputTasksHeader;
